import '../../util/string';
import moment from 'moment';

export enum AccessManagerResourceActionType {
    ErrorId = 0,
    ApplicationAccess = 1,
    WindowAccess = 2,

    MenuVisibility = 3,
    TabVisibility = 5,
    ControlVisibility = 6,
    ListVisibility = 9,
    ColumnVisibility = 12,
    PropertyVisibility = 21,

    MenuEnabled = 4,
    ControlEnabled = 7,
    PropertyEnabled = 22,

    RightClickOverList = 11,
    DoubleClickOverList = 10,

    ProcessExecution = 15,
    ExecutionFromKeyboard = 16,
    ExecuteApiGet = 17,
    ExecuteApiPost = 18,
    ExecuteApiPut = 19,
    ExecuteApiDelete = 20,

    FilterOnColumn = 14,
    OderingOnColumn = 13,

    ControlMandatory = 8,
    PropertyMandatory = 23,
}

export class AccessManagerResourceAction {
    public ActionTypeId: AccessManagerResourceActionType;
    public Description: string;
    public AllowChk: boolean;

    constructor();
    constructor(actionTypeId: AccessManagerResourceActionType, description: string, allowChk: boolean);
    constructor(actionTypeId?: AccessManagerResourceActionType, description?: string, allowChk?: boolean) {
        this.ActionTypeId = actionTypeId || AccessManagerResourceActionType.ApplicationAccess;
        this.Description = description || '';
        this.AllowChk = allowChk || false;
    }
}

export class AccessManagerModel {

}

export class AccessManagerResource {
    public ResourceId: number;
    public ResourceName: string;
    public mResourceActions: AccessManagerResourceAction[];
    public mResourceNodes: AccessManagerResource[];
    public mModelNodes: AccessManagerModel[];
    private ttl: number;

    constructor();
    constructor(instance: AccessManagerResource);
    constructor(resourceId: number);
    constructor(resourceId: number, resourceName: string);
    constructor(instanceOrResourceId?: number | any, resourceName?: string, resourceActions?: AccessManagerResourceAction[], resourceNodes?: AccessManagerResource[], modelNodes?: any[]) {
        if (Number(instanceOrResourceId)) {
            this.ResourceId = Number(instanceOrResourceId) || -999999;
            this.ResourceName = resourceName || '';
            this.ResourceActions = resourceActions;
            this.ResourceNodes = resourceNodes;
            this.ModelNodes = modelNodes;
        } else {
            let instance = instanceOrResourceId;
            this.ResourceId = instance.ResourceId || -999999;
            this.ResourceName = instance.ResourceName;
            this.ResourceActions = instance.ResourceActions;
            this.ResourceNodes = instance.ResourceNodes;
            this.ModelNodes = instance.ModelNodes;
        }
    }

    public get ResourceActions(): AccessManagerResourceAction[] {
        return this.mResourceActions;
    }

    public set ResourceActions(value: AccessManagerResourceAction[]) {
        this.mResourceActions = value || [];
    }

    public getResourceAction(actionType: AccessManagerResourceActionType): boolean {
        return this.ResourceActions.find(x => x.ActionTypeId == actionType).AllowChk;
    }

    public get ResourceNodes(): AccessManagerResource[] {
        return this.mResourceNodes;
    }

    public set ResourceNodes(value: AccessManagerResource[]) {
        this.mResourceNodes = value || [];
    }

    public get ModelNodes(): AccessManagerModel[] {
        return this.mModelNodes;
    }

    public set ModelNodes(value: AccessManagerModel[]) {
        this.mModelNodes = value || [];
    }

    public setTTL(ttl: number) {
        this.ttl = ttl;
    }

    public get isAlive(): boolean {
        return moment().valueOf() < this.ttl;
    }

    public static generateDefaultAllow(resourceId: number): AccessManagerResource {
        let resource = new AccessManagerResource(resourceId);

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ApplicationAccess, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.WindowAccess, '', true));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.MenuVisibility, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.TabVisibility, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ControlVisibility, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ListVisibility, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ColumnVisibility, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.PropertyVisibility, '', true));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.MenuEnabled, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ControlEnabled, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.PropertyEnabled, '', true));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.RightClickOverList, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.DoubleClickOverList, '', true));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ProcessExecution, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecutionFromKeyboard, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiGet, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiPost, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiPut, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiDelete, '', true));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.FilterOnColumn, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.OderingOnColumn, '', true));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ControlMandatory, '', true));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.PropertyMandatory, '', true));

        return resource;
    }

    public static generateDefaultDeny(resourceId: number): AccessManagerResource {
        let resource = new AccessManagerResource(resourceId);

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ApplicationAccess, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.WindowAccess, '', false));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.MenuVisibility, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.TabVisibility, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ControlVisibility, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ListVisibility, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ColumnVisibility, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.PropertyVisibility, '', false));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.MenuEnabled, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ControlEnabled, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.PropertyEnabled, '', false));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.RightClickOverList, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.DoubleClickOverList, '', false));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ProcessExecution, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecutionFromKeyboard, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiGet, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiPost, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiPut, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ExecuteApiDelete, '', false));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.FilterOnColumn, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.OderingOnColumn, '', false));

        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.ControlMandatory, '', false));
        resource.ResourceActions.push(new AccessManagerResourceAction(AccessManagerResourceActionType.PropertyMandatory, '', false));

        return resource;
    }
}
